import { useEffect } from 'react';
import { setGlobalAlertData } from '../redux/slicers/activitySlicer';
import { useDispatch } from 'react-redux';

/**
 * Hook: useGlobalAlertBar
 * - Loads disaster-protocol.json from the app's public folder.
 * - Uses process.env.PUBLIC_URL if available (works with CRA / static builds).
 * - Falls back to root-relative path.
 * - Logs result or warnings if file not found; does not throw to avoid breaking the app.
 */
export const useGlobalAlertBar = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchDisasterStatus = async () => {
      try {
        // Build URL pointing to the public folder file.
        const url = `${process.env.PUBLIC_URL}/global_alert.json`;

        // Use no-cache so developer changes to the public file are picked up during development.
        const res = await fetch(url, { cache: 'no-cache' });

        if (!res.ok) {
          // File not present in public folder — log and exit gracefully.
          console.warn(`global_alert.json not available at ${url} (status: ${res.status})`);
          return;
        }

        const data = await res.json();
        if (data && (data?.title || data?.message)) dispatch(setGlobalAlertData(data));

      } catch (error) {
        console.error('Error fetching disaster status from public folder:', error);
      }
    };

    fetchDisasterStatus();
  }, []);

  return;
};
